import { ThemeAlwaysAnimateOnLandBehaviour } from "behaviours/theme-always-animate-land-behaviour";
import { TintDimSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/tint-dim-symbol-behaviour";
import { SymbolSubcomponent } from "slotworks/components/matrix/symbol/symbol-subcomponent";

export class ThemeTintDimSymbolBehaviour extends TintDimSymbolBehaviour {

    public behaviourName: string = "ThemeTintDim";

    constructor(symbol: SymbolSubcomponent, protected dimTint: number = 0x333333) {
        super(symbol);
    }

    // We need check to see if the symbol is animating a land animation, so we can turn the animation off in the event of a dim.
    public override highlightDim() {
        let symbolAnimateBehavior = this.symbol.getBehaviourByName("ThemeAlwaysAnimateOnLand") as ThemeAlwaysAnimateOnLandBehaviour;
        symbolAnimateBehavior?.resolveUnfinishedAnimation();
        return super.highlightDim();
    }
}
